// Foundations
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

// rxjs
import { map } from 'rxjs';
import { Observable } from 'rxjs';

// Services
import { ConfirmDialogComponent } from '../components/_share/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  confirmDiscard(): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'general-dialog',
      data: {
        title: 'You have unsaved changes.',
        content: 'Do you want to keep editing or discard them?',
        cancelText: 'Keep',
        okText: 'Discard',
        okFn: () => dialogRef.close('discard'),
      },
      autoFocus: false,
    });
    return dialogRef.afterClosed().pipe(map((result) => result === 'discard'));
  }

  showAlert({
    title = 'OOPS!',
    content,
    okText = 'OK',
    okCallback,
  }: {
    title?: string;
    content: string;
    okText?: string;
    okCallback?: any;
  }): void {
    //
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'general-dialog',
      data: {
        title,
        content,
        okText,
        okFn: () => {
          dialogRef.close();
          //
          if (okCallback) {
            okCallback();
          }
        },
      },
      autoFocus: false,
      disableClose: true,
    });
  }
}
